import {
  hasPaidLicense,
  isInLegacyGracePeriod,
} from './paywall-grace-day-count';
import {
  getPersonalTrialDayCounts,
  type TrialLicense,
} from './trial-license-day-count';

/** Whether the user is on a personal trial or legacy-free grace period (TE-2506). */
export function isInTrialOrGracePeriod(licenses: TrialLicense[]): boolean {
  if (hasPaidLicense(licenses)) {
    return false;
  }

  if (getPersonalTrialDayCounts(licenses) !== null) {
    return true;
  }

  return isInLegacyGracePeriod(licenses);
}

/**
 * Whether to show the Pro feature badge on a gated UI element.
 * Paid users never see it; trial/grace users see it even while access is still allowed.
 */
export function shouldShowProFeatureBadge(
  canUseFeature: boolean,
  licenses: TrialLicense[],
): boolean {
  if (hasPaidLicense(licenses)) {
    return false;
  }

  return !canUseFeature || isInTrialOrGracePeriod(licenses);
}
